module.exports = __webpack_public_path__ + "static/media/20201114_115205_078_IMG_9904.ca3fd62b.jpg";